import { render } from "./RequestItem.vue?vue&type=template&id=01a5a0ec&scoped=true"
import script from "./RequestItem.vue?vue&type=script&lang=js"
export * from "./RequestItem.vue?vue&type=script&lang=js"

import "./RequestItem.vue?vue&type=style&index=0&id=01a5a0ec&scoped=true&lang=css"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a5a0ec"]])

export default __exports__